import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonGroupProps,
  Typography,
} from "@mui/material";
import React from "react";
import {
  FieldValues,
  useController,
  UseControllerProps,
} from "react-hook-form";
import { CarPosition } from "../models/car";
import { EmojiEvents } from "@mui/icons-material";

const getPositionIcon = (position: CarPosition, selected: boolean) => {
  const config = {
    "1st": { text: "1er", color: "#FFD700" },
    "2nd": { text: "2nd", color: "#BCC6CC" },
    "3rd": { text: "3e", color: "#CD7F32" },
  }[position];

  if (!config) return null;

  const { text, color } = config;

  return (
    <Box display="flex" flexDirection="column" alignItems="center" width={25}>
      <Typography
        variant="caption"
        fontWeight="bold"
        fontStyle={{
          color: selected ? color : "",
        }}
      >
        {text}
      </Typography>
      <EmojiEvents htmlColor={selected ? color : ""} fontSize="small" />
    </Box>
  );
};

export type PositionInputProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<ToggleButtonGroupProps, "value" | "defaultValue">;

export function PositionInput<T extends FieldValues>({
  name,
  control,
  defaultValue,
  rules,
  shouldUnregister,
  ...props
}: PositionInputProps<T>) {
  const {
    field: { value, onChange: fieldOnChange, ...field },
    fieldState,
  } = useController<T>({
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
  });

  return (
    <ToggleButtonGroup
      value={value}
      defaultValue={value}
      exclusive
      onChange={(_, newValue) => {
        fieldOnChange(newValue ?? "other");
      }}
      size="small"
      {...field}
      {...props}
    >
      <ToggleButton value="1st">
        {getPositionIcon("1st", value === "1st")}
      </ToggleButton>
      <ToggleButton value="2nd">
        {getPositionIcon("2nd", value === "2nd")}
      </ToggleButton>
      <ToggleButton value="3rd">
        {getPositionIcon("3rd", value === "3rd")}
      </ToggleButton>
    </ToggleButtonGroup>
  );
}

export default PositionInput;
